import StateBadge from './StateBadge';

export default StateBadge;
